export default __webpack_public_path__ + "static/media/helmet.8ba5e295.svg";